import React, { useState } from "react";
import "./Managerpersonlprofile.css";

const PersonalProfileForm = () => {
  const [profilePic, setProfilePic] = useState(null);

  const handleProfileUpload = (e) => {
    const file = e.target.files[0];
    if (file) setProfilePic(URL.createObjectURL(file));
  };

  return (
    <div className="layout">
      {/* LEFT PROFILE BOX */}
      {/* <div className="profile-box">
        <img
          src={
            profilePic ||
            "https://cdn-icons-png.flaticon.com/512/847/847969.png"
          }
          alt="Profile"
        />

        <label className="upload-btn">
          Change Photo
          <input type="file" accept="image/*" onChange={handleProfileUpload} />
        </label>
      </div> */}

      {/* RIGHT FORM SIDE */}
      <div className="right-form">
        <Card title="Personal Information">
  <div className="personal-row">
    
    {/* LEFT IMAGE COLUMN */}
    <div className="profile-box">
      <img
        src={
          profilePic ||
          "https://cdn-icons-png.flaticon.com/512/847/847969.png"
        }
        alt="Profile"
      />

      <label className="upload-btn">
        Change Photo
        <input
          type="file"
          accept="image/*"
          onChange={handleProfileUpload}
        />
      </label>
    </div>

    {/* RIGHT FORM COLUMN */}
    <div className="personal-form">
      <Grid>
        <Input label="First Name" required />
        <Input label="Middle Name" />
        <Input label="Last Name" required />
        <Input label="Father Name" required />
        <Input label="Mother Name" required />
        <Input label="Date of Birth" type="date" required />
        <Input label="Email ID" type="email" required />
        <Input label="Phone Number" type="tel" required />
        <Input label="Alternative Phone" type="tel" />
      </Grid>
    </div>

  </div>
</Card>


        <Card title="Address Details">
          <Grid>
            <Input label="Address Type" />
            <Input label="Country" />
            <Input label="State" />
            <Input label="City" />
            <Input label="House No." />
            <Input label="Area" />
            <Input label="Landmark" />
            <Input label="Pincode" />
          </Grid>
        </Card>

        <Card title="KYC Documents">
          <Grid>
            <File label="🆔 Aadhar Card" />
            <File label="💳 PAN Card" />
            <File label="🚗 Driving License" />
            <File label="🛂 Passport" />
            <File label="🗳️ Voter ID" />
          </Grid>
        </Card>

        <Card title="Bank Details">
          <Grid>
            <Input label="Account Holder Name" />
            <Input label="Bank Name" />
            <Input label="Account Number" />
            <Input label="IFSC Code" />
            <Input label="Branch Name" />
            <Input label="Branch City" />
            <Input label="UAN Number" />
          </Grid>
        </Card>

        <Card title="Social Media">
          <Grid>
            <Input label="LinkedIn" type="url" />
            <Input label="Facebook" type="url" />
            <Input label="Twitter" type="url" />
            <Input label="Instagram" type="url" />
          </Grid>
        </Card>

        <button className="save-btn">Save Profile</button>
      </div>
    </div>
  );
};

const Card = ({ title, children }) => (
  <div className="card">
    <h3>{title}</h3>
    {children}
  </div>
);

const Grid = ({ children }) => (
  <div className="grid">{children}</div>
);

const Input = ({ label, type = "text", required }) => (
  <div className="field">
    <label>
      {label} {required && <span>*</span>}
    </label>
    <input type={type} />
  </div>
);

const File = ({ label }) => (
  <div className="field">
    <label>{label}</label>
    <input type="file" />
  </div>
);

export default PersonalProfileForm;
